(function () {
  'use strict';

  var RETRY_MAX = 10;
  var RETRY_DELAY = 300;
  var retries = 0;

  function getSellingPlanDiscount() {
    try {
      var config = window.AppstleSubscription && window.AppstleSubscription.Config;
      if (!config) return null;
      var plansJson = config.sellingPlansJson;
      if (!plansJson || !plansJson.length) return null;
      // Find the highest discount percentage among enabled plans
      var best = null;
      for (var i = 0; i < plansJson.length; i++) {
        var plan = plansJson[i];
        if (plan.discountEnabled && plan.discountType === 'PERCENTAGE') {
          var offer = parseFloat(plan.discountOffer) || 0;
          if (best === null || offer > best) best = offer;
        }
      }
      return best;
    } catch (e) {
      return null;
    }
  }

  function injectSavings() {
    var wrappers = document.querySelectorAll('.appstle_subscription_cart_wrapper');
    if (wrappers.length === 0 && retries < RETRY_MAX) {
      retries++;
      setTimeout(injectSavings, RETRY_DELAY);
      return;
    }

    var hasContent = false;
    wrappers.forEach(function (w) {
      if (w.querySelector('.appstle_discount_text') || w.querySelector('.appstle_subscribe_selected_wrapper') || w.querySelector('.appstle_one_time_details_wrapper')) {
        hasContent = true;
      }
    });

    if (!hasContent && retries < RETRY_MAX) {
      retries++;
      setTimeout(injectSavings, RETRY_DELAY);
      return;
    }

    var discountPercent = getSellingPlanDiscount();

    wrappers.forEach(function (wrapper) {
      if (wrapper.querySelector('.cart-savings-amount')) return;

      var cartItem = wrapper.closest('.cart-item');
      if (!cartItem) return;

      var checkbox = cartItem.querySelector('.cart-item__checkbox');
      if (!checkbox) return;

      var quantity = parseInt(checkbox.dataset.quantity) || 1;
      var sellingPlan = checkbox.dataset.sellingPlan;
      var savingsAmount = 0;

      if (sellingPlan) {
        // Already subscribed: calculate from original vs final price
        var originalLinePrice = parseFloat(checkbox.dataset.originalLinePrice) || 0;
        var finalLinePrice = parseFloat(checkbox.dataset.linePrice) || 0;
        savingsAmount = (originalLinePrice - finalLinePrice) / 100;
      } else if (discountPercent !== null && discountPercent > 0) {
        // Not subscribed: estimate savings from selling plan discount
        var originalLinePrice = parseFloat(checkbox.dataset.originalLinePrice) || 0;
        savingsAmount = (originalLinePrice / 100) * (discountPercent / 100);
      }

      if (savingsAmount <= 0.01) return;

      // Extract currency symbol from page (default to $)
      var currencySymbol = '$';
      var priceEl = document.querySelector('.totals__total-value');
      if (priceEl) {
        var prefix = priceEl.textContent.match(/^[^\d]*/);
        if (prefix && prefix[0].trim()) currencySymbol = prefix[0].trim();
      }
      var savingsFormatted = currencySymbol + savingsAmount.toFixed(2);
      var discountText = wrapper.querySelector('.appstle_highest_discount') || wrapper.querySelector('.appstle_discount_text');
      if (discountText) {
        var span = document.createElement('span');
        span.className = 'cart-savings-amount';
        span.textContent = ' — Save ' + savingsFormatted;
        discountText.appendChild(span);
      }
    });

    retries = 0;
  }

  function runInjectSavings() {
    retries = 0;
    injectSavings();
  }

  if (window.location.pathname === '/cart' || document.querySelector('cart-items, cart-drawer-items')) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(runInjectSavings, 500); });
    } else {
      setTimeout(runInjectSavings, 500);
    }

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(runInjectSavings, 600);
      });
    }
  }
})();
